export default "__VITE_ASSET__DuOFLim6__"